import { DisplayCards } from './DisplayCards';
import 'url-search-params-polyfill';
import 'whatwg-fetch';

/**
 * pagination for arrays
 *
 */
const LoadMore = (targetSelector) => {
	const targets = document.querySelectorAll(targetSelector);

	Array.from(targets).map(target => {
		// console.log(target.dataset.page);
		let max = target.dataset['maxNumPages'];
		let page = target.dataset['page'];
		let action = target.dataset['action'];
		let postType = target.dataset['postType'];
		let postsPerPage = target.dataset['postsPerPage'];
		let order = target.dataset['order'];
		let orderBy = target.dataset['orderby'];
		let metaKey = target.dataset['metaKey'];
		let taxonomy = target.dataset['taxonomy'];
		let terms = target.dataset['terms'];
		let field = target.dataset['field'];
		let componentType = target.dataset['componentType'];

		target.addEventListener('click', function (e) {

			if (page < max) {
				let params = new URLSearchParams({
					'action': action,
					'post_type': postType,
					'posts_per_page': postsPerPage,
					'page': page,
					'order': order,
					'orderby': orderBy,
					'meta_key': metaKey,
					'max-num-pages': max,
					'taxonomy': taxonomy,
					'terms': terms,
					'field': field,
					'component_type': componentType,
				});

				let appendTarget = document.querySelector(e.target.dataset['targetSelector']);

				fetch(loadmore.ajax_url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
					},
					body: params.toString(),
					credentials: 'same-origin'
				})
					.then(response => response.text())
					.then(data => {
						DisplayCards(appendTarget, data);
						page++;
						if (page >= max) {
							e.target.innerHTML = 'All Pages Loaded';
						}
					});

			}
			e.preventDefault();
		});
	});

};

export default LoadMore;
